import {UbicacionEntity} from "../../../../views/masivos/datosGenerales/entities/ubicacion_entity"

export const CIUDADES: UbicacionEntity[] = [
  {Codigo: 1, Nombre: 'Quito'},
  {Codigo: 2, Nombre: 'Guayaquil'},
  {Codigo: 3, Nombre: 'Cuenca'},
  {Codigo: 4, Nombre: 'Ambato'},
  {Codigo: 5, Nombre: 'Santo Domingo'},
  {Codigo: 6, Nombre: 'Manta'}
];



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabecera/entity/ciudades.ts